import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getFormControl',
  pure: false
})
export class GetFormControlPipe implements PipeTransform {

  transform(controlName:any, getType: string = "", controlKeyName: string = ""): any {
    if (getType === "length") {
      return Object.keys(controlName.controls).length;
    } else if (getType === "referList") {
      let referList = [];
      if (controlKeyName) {
        let CurrentControlValue = controlName.controls[controlKeyName].value;
        if (CurrentControlValue) {
          referList = CurrentControlValue?.referList
        }
      }
      return referList;
    } else {
      return controlName.controls;
    }
  }

}
